/**
 * Composable pour la gestion des commerciaux dans les quotes
 * Limite: 100 lignes max
 */

import { ref, computed } from 'vue'
import { usersService } from '../../services/index.js'

export function useQuoteCommercials() {
  const commercials = ref([])

  const loadCommercials = async () => {
    try {
      const data = await usersService.getCommercials()
      commercials.value = data.commercials || []
    } catch (err) {
      console.error('Erreur lors du chargement des commerciaux:', err)
    }
  }

  const availableCommercials = computed(() => {
    return commercials.value
  })

  const getCommercialsForSelect = (quote) => {
    const baseCommercials = availableCommercials.value
    if (quote?.assigned_user_id) {
      const assignedCommercial = commercials.value.find(c => c.id === quote.assigned_user_id)
      if (assignedCommercial && !baseCommercials.find(c => c.id === assignedCommercial.id)) {
        return [...baseCommercials, assignedCommercial]
      }
    }
    return baseCommercials
  }

  return {
    commercials,
    availableCommercials,
    getCommercialsForSelect,
    loadCommercials
  }
}
